import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-61bb01d0"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "service",
  class: "service-wrap ptb-100"
}
const _hoisted_2 = { class: "container" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-xl-8 offset-xl-2 col-lg-10 offset-lg-1" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "section-title style1 text-center mb-40" }, [
      /*#__PURE__*/_createElementVNode("span", { class: "custom-banner-subtitle" }, "Echipa medicală")
    ])
  ])
], -1))
const _hoisted_4 = ["href"]
const _hoisted_5 = { class: "service-card style1" }
const _hoisted_6 = { class: "service-img" }
const _hoisted_7 = ["src"]
const _hoisted_8 = {
  key: 0,
  class: "founder-badge"
}
const _hoisted_9 = { class: "service-info" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Slide = _resolveComponent("Slide")!
  const _component_Navigation = _resolveComponent("Navigation")!
  const _component_Carousel = _resolveComponent("Carousel")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_Carousel, {
        autoplay: 5000,
        "wrap-around": true,
        breakpoints: _ctx.breakpoints,
        "pause-autoplay-on-hover": "",
        class: "service-slider-one"
      }, {
        addons: _withCtx(() => [
          _createVNode(_component_Navigation)
        ]),
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.services, (service) => {
            return (_openBlock(), _createBlock(_component_Slide, {
              key: service.id
            }, {
              default: _withCtx(() => [
                _createElementVNode("a", {
                  href: service.url
                }, [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("img", {
                        src: service.image,
                        alt: "Image"
                      }, null, 8, _hoisted_7),
                      (service.badge)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(service.badge), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("h3", null, _toDisplayString(service.name), 1),
                      _createElementVNode("p", null, _toDisplayString(service.designation), 1)
                    ])
                  ])
                ], 8, _hoisted_4)
              ]),
              _: 2
            }, 1024))
          }), 128))
        ]),
        _: 1
      }, 8, ["breakpoints"])
    ])
  ]))
}